<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <modal
      :show.sync="tableModal"
      header-classes="bg-primary p-3 "
      class="modal-lg"
      size="lg"
    >
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Orders
      </h6>
      <VendorTable :selectedName="selectedName" />
      <!-- <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="tableModal = false"
          >CLOSE</base-button
        >
      </template> -->
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Store Transactions
        </h2>
        <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
        Transactions
      </base-button>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color "
      :data="TagsData"
    >
      <el-table-column
        label="Created at "
        prop="Created"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.Created }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Store Name"
        min-width="200px"
        prop="vendorname"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.vendorname }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Sales"
        min-width="150px"
        prop="totalearning"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.totalearning }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Base Amount"
        min-width="180px"
        prop="BaseAmount"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.BaseAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="TDS" min-width="180px" prop="TDS" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.TDS }}</span>
        </template>
      </el-table-column>
      <el-table-column label="GST" min-width="180px" prop="GST" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.GST }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Commission Fee"
        min-width="180px"
        prop="commission"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.commission }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Paid"
        min-width="200px"
        prop="totalpaid"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.totalpaid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Total Due"
        min-width="150px"
        prop="totaldue"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.totaldue }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Transaction ID"
        min-width="180px"
        prop="TransactionID"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.TransactionID }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Transaction Type"
        min-width="180px"
        prop="Transaction"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.Transaction }}</span>
        </template>
      </el-table-column>
      <!-- 
      <el-table-column
        label="Sub Tags"
        min-width="170px"
        prop="orderno"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.subtags }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="Action" min-width="150px">
        <template v-slot="{ row }">
          <div class="flex items-center">
            <div
              class="flex items-center mr-4 cursor-pointer"
              data-toggle="tooltip"
              data-placement="top"
              title="Pay"
            >
              <feather-icon
                @click="editModal = true"
                block
                icon="CreditCardIcon"
                svgClasses="w-5"
              ></feather-icon>
            </div>
            <div
              class="flex items-center cursor-pointer"
              data-toggle="tooltip"
              data-placement="top"
              title="View"
            >
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5"
                @click="
                  tableModal = true;
                  selectedName = row.vendorname;
                "
                block
              ></feather-icon>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";

import TableTagsData from "./components/TableTagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import VendorTable from "./components/VendorTable";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar,
    VendorTable
  },
  data() {
    return {
      TagsData,
      TableTagsData,
      currentPage: 1,
      editModal: false,
      tableModal: false,
      openAddBannerSidebar: false,
      selectedName: ""
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
